import React from 'react';
import { connect } from 'react-redux';

import PunchOutCheckout from '../components/punchOut/PunchOutCheckout';
import PunchOutCheckoutNortel2 from '../components/punchOut/PunchOutCheckoutNortel2';
import PunchOutCheckoutNortel3 from '../components/punchOut/PunchOutCheckoutNortel3';
import PunchOutCheckoutNortel4 from '../components/punchOut/PunchOutCheckoutNortel4';
import PunchOutCheckoutNortel5 from '../components/punchOut/PunchOutCheckoutNortel5';
import PunchOutCheckoutNortel6 from '../components/punchOut/PunchOutCheckoutNortel6';
import PunchOutCheckoutNortel7 from '../components/punchOut/PunchOutCheckoutNortel7';
import PunchOutCheckoutNortel8 from '../components/punchOut/PunchOutCheckoutNortel8';
import PunchOutCheckoutNortel9 from '../components/punchOut/PunchOutCheckoutNortel9';
import PunchOutCheckoutNortel10 from '../components/punchOut/PunchOutCheckoutNortel10';
import PunchOutCheckoutNortel11 from '../components/punchOut/PunchOutCheckoutNortel11';
import PunchOutCheckoutNortel12 from '../components/punchOut/PunchOutCheckoutNortel12';
import PunchOutCheckoutNortel13 from '../components/punchOut/PunchOutCheckoutNortel13';
import PunchOutCheckoutNortel14 from '../components/punchOut/PunchOutCheckoutNortel14';
import PunchOutCheckoutNortel15 from '../components/punchOut/PunchOutCheckoutNortel15';
import PunchOutCheckoutNortel16 from '../components/punchOut/PunchOutCheckoutNortel16';
import PunchOutCheckoutNortel17 from '../components/punchOut/PunchOutCheckoutNortel17';
import PunchOutCheckoutNortel18 from '../components/punchOut/PunchOutCheckoutNortel18';
import PunchOutCheckoutNortel19 from '../components/punchOut/PunchOutCheckoutNortel19';
import PunchOutCheckoutNortel20 from '../components/punchOut/PunchOutCheckoutNortel20';
import PunchOutCheckoutNortel21 from '../components/punchOut/PunchOutCheckoutNortel21';
import PunchOutCheckoutNortel22 from '../components/punchOut/PunchOutCheckoutNortel22';
import PunchOutCheckoutNortel23 from '../components/punchOut/PunchOutCheckoutNortel23';
import PunchOutCheckoutNortel24 from '../components/punchOut/PunchOutCheckoutNortel24';

const PunchOutCheckoutPage = ({ punchoutRule, location }) => {
  const isPushPunchout = location && location.state && location.state.isPushPunchout;

  const validateLayout = () => {
    switch (punchoutRule) {
      case 'NORTEL2': // PunchOut Ariba Cargill
        return <PunchOutCheckoutNortel2 isPushPunchout={isPushPunchout} />;
      case 'NORTEL3': // PunchOut Statkraft
        return <PunchOutCheckoutNortel3 isPushPunchout={isPushPunchout} />;
      case 'NORTEL4': // PunchOut Ariba Usiminas
        return <PunchOutCheckoutNortel4 isPushPunchout={isPushPunchout} />;
      case 'NORTEL5': // PunchOut Coupa
        return <PunchOutCheckoutNortel5 isPushPunchout={isPushPunchout} />;
      case 'NORTEL6': // PunchOut Vale
        return <PunchOutCheckoutNortel6 isPushPunchout={isPushPunchout} />;
      case 'NORTEL7': // PunchOut Ariba SKF
        return <PunchOutCheckoutNortel7 isPushPunchout={isPushPunchout} />;
      case 'NORTEL8': // PunchOut Ariba Boticário
        return <PunchOutCheckoutNortel8 isPushPunchout={isPushPunchout} />;
      case 'NORTEL9': // PunchOut Ariba Bayer
        return <PunchOutCheckoutNortel9 isPushPunchout={isPushPunchout} />;
      case 'NORTEL10': // Punchout Ariba Petrobras
        return <PunchOutCheckoutNortel10 isPushPunchout={isPushPunchout} />;
      case 'NORTEL11': // PunchOut Ariba Gerdau
        return <PunchOutCheckoutNortel11 isPushPunchout={isPushPunchout} />;
      case 'NORTEL12': // PunchOut Ariba Faurecia
        return <PunchOutCheckoutNortel12 isPushPunchout={isPushPunchout} />;
      case 'NORTEL13': // PunchOut Ariba Tetrapak
        return <PunchOutCheckoutNortel13 isPushPunchout={isPushPunchout} />;
      case 'NORTEL14': // PunchOut Anglo American
        return <PunchOutCheckoutNortel14 isPushPunchout={isPushPunchout} />;
      case 'NORTEL15': // PunchOut Michelin Brazil
        return <PunchOutCheckoutNortel15 isPushPunchout={isPushPunchout} />;
      case 'NORTEL16': // PunchOut Ariba Baker
        return <PunchOutCheckoutNortel16 isPushPunchout={isPushPunchout} />;
      case 'NORTEL17': // PunchOut John Deere
        return <PunchOutCheckoutNortel17 isPushPunchout={isPushPunchout} />;
      case 'NORTEL18': // PunchOut Lycra
        return <PunchOutCheckoutNortel18 isPushPunchout={isPushPunchout} />;
      case 'NORTEL19': // PunchOut Sanofi
        return <PunchOutCheckoutNortel19 isPushPunchout={isPushPunchout} />;
      case 'NORTEL20': // PunchOut Benteler
        return <PunchOutCheckoutNortel20 isPushPunchout={isPushPunchout} />;
      case 'NORTEL21': // PunchOut Magnesita
        return <PunchOutCheckoutNortel21 isPushPunchout={isPushPunchout} />;
      case 'NORTEL22': // PunchOut Mosaic
        return <PunchOutCheckoutNortel22 isPushPunchout={isPushPunchout} />;
      case 'NORTEL23': // PunchOut AGCO
        return <PunchOutCheckoutNortel23 isPushPunchout={isPushPunchout} />;
      case 'NORTEL24': // PunchOut Embraer
        return <PunchOutCheckoutNortel24 isPushPunchout={isPushPunchout} />;
      default: // PunchOut Padrão
        return <PunchOutCheckout isPushPunchout={isPushPunchout} />;
    }
  };

  return (
    <main>
      <div className="section section-panel">
        <div className="container">
          <div className="box-content">
            <div className="basket cart-status">
              {validateLayout()}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = state => ({
  punchoutRule: state.contracts.selected && state.contracts.selected.clientDetails.punchoutRule,
});

export default connect(mapStateToProps)(PunchOutCheckoutPage);
